import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../app.component';
import { WhitelabelService } from '../_services/whitelabel.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  

  AppComponent = AppComponent;
  url ="";
  constructor(private whitelabelService: WhitelabelService) {
    //this.url ="https://lifeportalstorage.blob.core.windows.net/static/images/lifestyle-innovations/privacy-policy.html"
    var setting =  JSON.parse(this.whitelabelService.getSettingByFeatureName('privacyPolicy'));
    console.log(setting)
    this.url = setting.htmlLink;
   }

  ngOnInit() {
    $('#privacyPolicyDiv').load(this.url)

  }

}



// WEBPACK FOOTER //
// ./src/app/privacy-policy/privacy-policy.component.ts